import clsx from 'clsx'
import { motion } from 'framer-motion'
import type { ReactNode, RefObject } from 'react'
import { wrapper } from './ScrollPast.css'
import { useHasScrolledPast } from './useHasScrolledPast'

export type ScrollPastProps = {
  targetRef: RefObject<HTMLElement>
  children: ReactNode
  className?: string
}

export function ScrollPast({ targetRef, children, className }: ScrollPastProps) {
  const hasScrolledPast = useHasScrolledPast({ targetRef })

  return (
    <motion.div
      className={clsx(wrapper, className)}
      variants={{
        hidden: { opacity: 0, transitionEnd: { display: 'none' } },
        visible: { opacity: 1, display: 'block' },
      }}
      initial="hidden"
      animate={hasScrolledPast ? 'visible' : 'hidden'}
    >
      {children}
    </motion.div>
  )
}
